/**
 * DDX-Plus Phase 2 — prohibited / discouraged source policy for authoritative retrieval.
 * @see phase2.md Feature E
 */

/** Domains or URL substrings that must never be used as authoritative clinical sources */
export const PROHIBITED_SOURCE_PATTERNS = Object.freeze([
  'wikipedia.org',
  'wikimedia.org',
  'reddit.com',
  'facebook.com',
  'twitter.com',
  'x.com',
  'tiktok.com',
  'pinterest.com',
  'quora.com',
  'yahoo.com/answers',
  'answers.yahoo',
  'healthboards.com',
  'patient.info', // consumer forum-style; not society-endorsed KB path
  'webmd.com', // commercial consumer health (per phase2 prohibited class)
  'verywellhealth.com',
  'verywellmind.com',
  'healthline.com',
  'drugs.com',
  'rxlist.com',
  'medscape.com', // paywalled mixed; prefer explicit guideline domains in registry
]);

/** Human-readable list for documentation and admin UI */
export const PROHIBITED_SOURCE_CATEGORIES = Object.freeze([
  'Wikipedia and open wikis',
  'Health forums and social Q&A',
  'Commercial consumer health sites and blogs',
  'AI-generated content and uncited LLM outputs',
  'Sources that are not peer-reviewed or society-endorsed',
]);

/**
 * @param {string} urlOrText
 * @returns {boolean} true if URL or text references a prohibited host/pattern
 */
export function isProhibitedSourceUrl(urlOrText) {
  if (urlOrText == null || typeof urlOrText !== 'string') return false;
  const lower = urlOrText.toLowerCase();
  return PROHIBITED_SOURCE_PATTERNS.some((p) => lower.includes(p));
}

/**
 * @param {string} domainRestriction - e.g. uptodate.com from registry accessConfig
 * @returns {boolean}
 */
export function isAllowedSearchDomain(domainRestriction) {
  if (!domainRestriction || typeof domainRestriction !== 'string') return false;
  const d = domainRestriction.trim().toLowerCase().replace(/^www\./, '');
  if (!d) return false;
  return !isProhibitedSourceUrl(d);
}
